module.exports = __webpack_public_path__ + "img/icn_money-paper-accent.daae6f0a.svg";